import React, { useState } from 'react';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

import UserCard from './UserCard';
import NewUserCard from './NewUserCard';
import CustomButton from '../../containers/Website/widgets/buttons/Button';
import { changePlan, registerPlan } from '../../services/sync';

import cardImg from '../../assets/icons/card.svg';
import plus from '../../assets/icons/plus.svg';

import styles from './ManageCards.module.scss';

import toaster from 'toasted-notes';
import 'toasted-notes/src/styles.css';
import SelectPaymentMethod from './SelectPaymentMethod';
const ManageCards = ({
  user,
  plansSection,
  loadCards,
  cardList,
  reloadStore,
  selectedPlan,
  active_plan,
  setSubscriptionStatus,
  setPaymentProcessing,
  setPlansSection,
}) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [addPlanLoading, setAddPlanLoading] = useState(false);
  const [createNewCard, setCreateNewCard] = useState(false);

  const [isOpen, setIsOpen] = React.useState(false);

  const handleSetSelectedCard = (cardId, checked) => {
    if (checked) {
      setSelectedCard(cardId);
    } else {
      setSelectedCard(null);
    }
    setIsOpen(false);
  };

  React.useEffect(() => {
    let defaultCard = undefined;
    if (cardList?.data?.length > 0) {
      defaultCard = cardList?.data?.find((card) => card?.make_default === 1);
    }
    if (defaultCard) {
      handleSetSelectedCard(defaultCard.hidden_id, true);
    } else if (!defaultCard && cardList?.data?.length > 0) {
      handleSetSelectedCard(cardList?.data?.[0]?.hidden_id, true);
    }
  }, [cardList]);

  const processPayment = async () => {
    try {
      setAddPlanLoading(true);
      setSubscriptionStatus(true);
      if (selectedCard) {
        let payload = {
          plan_id: selectedPlan.id,
          user_plan_id: active_plan === null ? false : active_plan?.plan_id,
          card_id: selectedCard,
        };
        if (active_plan) {
          await changePlan(payload);
          toaster.notify('Your plan was changed successfully.', {
            duration: '4000',
            position: 'bottom',
          });
          reloadStore(true);
          setPaymentProcessing(true);
          setAddPlanLoading(false);
          setPlansSection('confirmation');
        } else {
          await registerPlan(payload);
          toaster.notify('You have purchased this successfully.', {
            duration: '4000',
            position: 'bottom',
          });
          reloadStore(true);
          setPaymentProcessing(true);
          setAddPlanLoading(false);
          setPlansSection('confirmation');
        }
      }
    } catch (e) {
      setAddPlanLoading(false);
      setPaymentProcessing(false);
    }
    setSelectedCard(null);
  };

  const selectedCardDetails = cardList?.data?.find((card) => card?.hidden_id === selectedCard);

  return (
    <>
      {isOpen ? (
        <SelectPaymentMethod
          open={isOpen}
          handleClose={() => setIsOpen(false)}
          cardList={cardList}
          handleSetSelectedCard={handleSetSelectedCard}
          selectedCard={selectedCard}
        />
      ) : null}

      {plansSection === 'payment' && (
        <div className='payment'>
          <div className='container'>
            {!createNewCard  ? (
              <div className={styles.wrapper}>
                <button className={styles.select_payment_card} onClick={() => setIsOpen(true)}>
                  Select Payment Method
                  <span>
                    <KeyboardArrowDown />
                  </span>
                </button>
                {selectedCardDetails ? (
                  <div className={styles.payment_cards_container}>
                    <UserCard selectedCardDetails={selectedCardDetails} />
                  </div>
                ) : null}
                <CustomButton
                  text='Add New Card'
                  img={plus}
                  styling='bg-bd5-5-fx font-12 button-4 mt-2 full-input mb-3'
                  function={() => setCreateNewCard(!createNewCard)}
                />
              </div>
            ) : null}
            {createNewCard ? <NewUserCard user={user} loadCards={loadCards} setCreateNewCard={setCreateNewCard} /> : ''}
            <div>
              <div className='card2 plan-details'>
                <div className='head'>
                  <div className='bold'>Your new plan</div>
                </div>
                {selectedPlan
                  ? (() => {
                      let description = JSON.parse(selectedPlan.description);
                      let meta = JSON.parse(selectedPlan.meta);
                      return (
                        <div className='plan-details-container font-12'>
                          <div className='items-container'>
                            <div className='item'>
                              <span>{selectedPlan?.name} (Monthly)</span>
                              <span className='bold'>
                                {selectedPlan.currency}
                                {selectedPlan.price}
                              </span>
                            </div>
                            <div className='item'>
                              <span>
                                {description?.orgs} {description?.orgs === 1 ? 'Organisation' : 'Organisations'}
                              </span>
                            </div>
                            <div className='item'>
                              <span>
                                {meta?.connection} {meta?.connection === 1 ? 'Connection' : 'Connections'}
                              </span>
                            </div>
                          </div>
                          <div className='items-container font-18 bold'>
                            <div className='item'>
                              <span>Total</span>
                              <span>
                                {selectedPlan.currency}
                                {selectedPlan.price}
                              </span>
                            </div>
                          </div>
                          <div className='items-container'>
                            <div className='item color-9'></div>
                          </div>
                          <div className='item'>
                            <CustomButton
                              text={addPlanLoading ? 'PLEASE WAIT...' : 'Pay'}
                              img={cardImg}
                              disable={!selectedPlan || selectedCard === null || addPlanLoading ? true : false}
                              styling={
                                !selectedPlan || selectedCard === null
                                  ? 'bg-bd6-6 font-12 button-4 full-input color-10'
                                  : 'bg-bd2-2 font-12 button-4 full-input'
                              }
                              function={() => processPayment()}
                            />
                          </div>
                        </div>
                      );
                    })()
                  : ''}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageCards;
